// @flow strict

const alreadyWarned = [];

export type deprecateCategoryType = 'PROP' | 'COMPONENT';

export const deprecateMessage = (key: string, version: string) => {
  if (process.env.NODE_ENV !== 'production') {
    const warning = `${key} will no longer be supported from ACE-REACT ${version}`;

    if (!alreadyWarned.includes(warning)) {
      alreadyWarned.push(warning);
      // eslint-disable-next-line no-console
      console.warn(warning);
    }
  }
};

export const deprecatePropRemap = (
  props: Object,
  prop: string,
  remapTo: string,
  version: string,
  componentName: string,
) => {
  if (typeof props[prop] !== 'undefined') {
    deprecateMessage(`${componentName} ${prop} prop has changed to ${remapTo}. ${prop}`, version);
    const newProps = Object.assign({}, props, { [remapTo]: props[prop] }); // eslint-disable-line no-param-reassign
    delete newProps[prop]; // eslint-disable-line no-param-reassign
    Object.preventExtensions(newProps);
    return newProps; // eslint-disable-line no-param-reassign
  }

  return props;
};

export const deprecateProp = (
  prop: *,
  propName: string,
  version: string,
  componentName: string,
) => {
  if (typeof prop !== 'undefined') {
    deprecateMessage(`${componentName} ${prop} prop `, version);
  }
};

export const deprecateComponent = (name: string, version: string) => {
  deprecateMessage(`${name} component`, version);
};

export const deprecateComponentRemap = (name: string, remapTo: string, version: string) => {
  deprecateMessage(`${name} component has changed to ${remapTo}`, version);
};
